import { useState } from "react";
import { useGetVideosQuery } from "../../../features/videos/videosApi";
import { useAddAssignmentMutation } from "../../../features/assignment/assignmentApi";

export default function AddAssignment() {
  const [title, setTitle] = useState("");
  const [mark, setMark] = useState("");
  const [videoId, setVideoId] = useState("");
  const [videoTitle, setVideoTitle] = useState("");
  const [
    addAssignment,
    {
      isLoading: addAssignmenLoading,
      isSuccess: addAssignmentSucess,
      isError: addAssignmentError,
    },
  ] = useAddAssignmentMutation();
  const handleSubmit = (e) => {
    e.preventDefault();
    addAssignment({
      title,
      totalMark: Number(mark),
      video_id: videoId,
      video_title: videoTitle,
    });
  };

  const optionsSelect = (e) => {
    setVideoId(e.target.value);
    setVideoTitle(e.target.selectedOptions[0].childNodes[0].data);
  };

  let option = null;
  const { data, isLoading, isError } = useGetVideosQuery();
  if (!isLoading && data)
    option = data.map((video, i) => (
      <option key={i} value={video.id}>
        {video.title}
      </option>
    ));

  return (
    <form className="video-form" onSubmit={handleSubmit}>
      <div className="space-y-2">
        <label>Select Video</label>
        <select
          name="video"
          className="text-input"
          value={videoId}
          onChange={optionsSelect}
        >
          <option hidden>Choose Video</option>
          {option}
        </select>
      </div>
      <div className="space-y-2">
        <label>Assignment Title</label>
        <input
          required
          className="text-input"
          type="text"
          name="title"
          value={title}
          placeholder="Enter Assignment Title"
          onChange={(e) => setTitle(e.target.value)}
        />
      </div>

      <button
        disabled={addAssignmenLoading}
        type="submit"
        className="submit"
        id="lws-submit"
      >
        Add Video
      </button>
      <div>
        {addAssignmentSucess && (
          <p className="text-center" style={{ color: "green" }}>
            Assignment add successfully
          </p>
        )}
        {addAssignmentError && (
          <p className="text-center" style={{ color: "red" }}>
            There was an error
          </p>
        )}
      </div>
    </form>
  );
}
